import { ServicesConfigs } from '../service.types'

const leaveRequestServiceConfigs: ServicesConfigs = {
  collectionName: 'LeaveRequests',
}

export default leaveRequestServiceConfigs
